import { WhatsappBanner } from "./whatsapp-banner";

const GOV_PI_SUPPORT_NUMBER = "86988788533";

export const WhatsappBannerContainer = () => {
  return <WhatsappBanner whatsappNumber={GOV_PI_SUPPORT_NUMBER} />;
};
